export const isValidURL = (url) => {
  if (!url) return false
  try {
    // eslint-disable-next-line no-new
    new URL(url)
    return true
  } catch (error) {
    return false
  }
}
